import { createFileRoute } from "@tanstack/react-router";

import { DialogPageLayout } from "@/components/DialogPageLayout";

export const Route = createFileRoute("/logged-out")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DialogPageLayout>
      <div>Je bent uitgelogd</div>
    </DialogPageLayout>
  );
}
